import moment from "moment";
import pdfMake from "pdfmake";
import { functions } from "@/firebase";
import { DEFAULT_CREDIT_NOTE } from "@/store/accounting/creditNotes";
// eslint-disable-next-line
const pdfFonts = require("pdfmake/build/vfs_fonts.js");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

/** Prefer Firestore doc id (`_id` from docsFromSnapshot); fall back to `id`. */
function documentId(doc) {
  if (!doc) return null;
  return doc._id || doc.id || null;
}

export function convertInvoiceToCreditNote(invoice) {
  return {
    ...DEFAULT_CREDIT_NOTE,
    sentDate: moment().format("YYYY-MM-DD"),
    invoiceNumber: invoice.number,
    invoiceId: documentId(invoice),
    from: invoice.from,
    to: invoice.to,
    items: invoice.items,
    stripeChargeId: invoice.stripeChargeId
  };
}
const getInvoicePdfDefinition = functions.httpsCallable(
  "getInvoicePdfDefinition"
);

function formatDocumentFileName(document, type) {
  const fromName =
    (document.from && document.from.name && String(document.from.name)) ||
    "document";
  return `${fromName.replace(/\s+/g, "-")}-${type}-#${
    document.number
  }-${moment().format("YYYY-MM-DD")}.pdf`;
}

async function fetchInvoicePdfDocDefinition(invoice) {
  const invoiceId = documentId(invoice);
  if (!invoiceId) {
    throw new Error("Invoice id is missing; cannot download PDF.");
  }
  const response = await getInvoicePdfDefinition({ invoiceId });

  return response.data;
}

export async function downloadInvoicePdf(invoice) {
  const docDefinition = await fetchInvoicePdfDocDefinition(invoice);

  return pdfMake
    .createPdf(docDefinition)
    .download(formatDocumentFileName(invoice, "invoice"));
}

const getCreditNotePdfDefinition = functions.httpsCallable(
  "getCreditNotePdfDefinition"
);

async function fetchCreditNotePdfDocDefinition(creditNote) {
  const creditNoteId = documentId(creditNote);
  if (!creditNoteId) {
    throw new Error("Credit note id is missing; cannot download PDF.");
  }
  const response = await getCreditNotePdfDefinition({
    creditNoteId
  });

  return response.data;
}

export async function downloadCreditNotePdf(creditNote) {
  const docDefinition = await fetchCreditNotePdfDocDefinition(creditNote);

  return pdfMake
    .createPdf(docDefinition)
    .download(formatDocumentFileName(creditNote, "credit-note"));
}
